import Resizer from "react-image-file-resizer";
import moment from "moment";
import { MEDIA_STORAGE } from "config/keys/main";

export const base64Thumbnail = (file, width, height) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "JPEG",
      70,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

export const base64Image = (file, width, height) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      "PNG",
      70,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

export const convertImage = (image) => {
  const randomString = `?v=${moment().valueOf()}`;
  const url = image?.includes(MEDIA_STORAGE) || false;
  const final = !url ? `${MEDIA_STORAGE}${image}${randomString}` : image || "";
  return final;
};
